<div class="col-12">
  <div class="card">
    <div class="card-header" style="padding-bottom: 0">
      <h4 class="modal-title">
        {{ (mode == 'update' ? 'Contract.edit' : 'Contract.add') | translate }}
      </h4>
      <hr />
    </div>
    @if (formGroupInitializedFlag) {
      <div [formGroup]="contractFormGroup" class="card-body" style="padding-top: 0">
        <div class="row">
          <div class="col-xl-3">
            <div class="form-group">
              <label [innerHtml]="'Contract.name' | translate" class="required"></label>
              <input formControlName="name" class="form-control" name="name" />
            </div>
            @if (mode === 'update') {
              <div class="form-group">
                <label [innerHtml]="'Contract.number' | translate"></label>
                <input formControlName="number" class="form-control" />
              </div>
            }
            <div class="form-group">
              <label [innerHtml]="'Contract.holder' | translate" class="required"></label>
              <app-admin-organization-selector
                [model]="contractFormGroup.get('holder').value"
                (modelChange)="contractFormGroup.get('holder').patchValue($event)"
              />
            </div>
            <div class="form-group">
              <label for="cdnEnabled">{{ 'Contract.cdnEnabled' | translate }}</label>
              <input formControlName="cdnEnabled" id="cdnEnabled" type="checkbox" />
            </div>
            <div class="form-group">
              <label for="secondaryClusterEnabled">{{ 'Contract.secondaryClusterEnabled' | translate }}</label>
              <input formControlName="secondaryClusterEnabled" id="secondaryClusterEnabled" type="checkbox" />
            </div>
          </div>

          <div class="col-xl-3">
            <div class="form-group">
              <label for="type">{{ 'Type' | translate }}</label>
              <ng-select id="type" formControlName="type" [clearable]="false">
                @for (type of ContractTypes; track type) {
                  <ng-option [value]="type">
                    {{ 'Contract.typeEnum.' + type | translate }}
                  </ng-option>
                }
              </ng-select>
            </div>

            <div class="form-group">
              <label for="mode">{{ 'siteMode' | translate }}</label>
              <ng-select
                formControlName="defaultSiteMode"
                placeholder="—"
                bindLabel="label"
                bindValue="value"
                id="mode"
              >
                <ng-option [value]="null">—</ng-option>
                @for (item of siteModes; track item) {
                  <ng-option [value]="item.value">{{ item.label }}</ng-option>
                }
              </ng-select>
            </div>
            @if (contractFormGroup.get('startDate').invalid || contractFormGroup.get('renewalDate').invalid) {
              <div class="bg-orange">
                <span>{{ 'StartRenewalDateWarning' | translate }}</span>
              </div>
            }
            <div class="row align-items-end">
              <div class="col-6">
                <div class="form-group">
                  <label [innerHtml]="'Contract.startDate' | translate"></label>
                  <input type="date" formControlName="startDate" class="form-control" />
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label>{{ 'Contract.endDate' | translate }}</label>
                  <input
                    type="date"
                    formControlName="endDate"
                    [min]="contractFormGroup.get('startDate').value"
                    class="form-control"
                  />
                </div>
              </div>
            </div>

            <div class="row align-items-end">
              @if (mode === 'update') {
                <div class="col-6">
                  <div class="form-group">
                    <label [innerHtml]="'CreatedAt' | translate"></label>
                    <input type="date" formControlName="createdAt" class="form-control" />
                  </div>
                </div>
              }
              <div [ngClass]="mode === 'create' ? 'col-12' : 'col-6'">
                <div class="form-group">
                  <label [innerHtml]="'Contract.renewDate' | translate" for="renew"></label>
                  <input type="date" formControlName="renewalDate" id="renew" class="form-control" />
                </div>
              </div>
            </div>

            <div class="row align-items-end">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="MRPM">{{ 'Contract.millionRequestsPerMonth' | translate }}</label>
                  <input
                    formControlName="millionRequestsPerMonth"
                    class="form-control"
                    id="MRPM"
                    min="0"
                    type="number"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="addBandwidth">
                    {{ 'Contract.addBandwidth' | translate }} ({{ 'SizeUnit.GB' | translate }} /
                    {{ 'month' | translate }})
                  </label>
                  <input
                    formControlName="additionalBandwidth"
                    class="form-control"
                    id="addBandwidth"
                    min="0"
                    type="number"
                  />
                </div>
              </div>
            </div>

            <div class="row align-items-end">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="nbSiteAdv">{{ 'Contract.nbSitesAdvanced' | translate }}</label>
                  <input formControlName="nbSitesAdvanced" class="form-control" id="nbSiteAdv" min="0" type="number" />
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="nbSiteExp">{{ 'Contract.nbSitesExpert' | translate }}</label>
                  <input formControlName="nbSitesExpert" class="form-control" id="nbSiteExp" min="0" type="number" />
                </div>
              </div>
            </div>
          </div>

          @if (mode == 'update') {
            <app-admin-contract-organizations
              [contractNumber]="contractFormGroup.get('number').value"
              class="col-xl-6"
            />
            <app-admin-contract-sites [contractNumber]="contractFormGroup.get('number').value" class="col-xl-12 mt-3" />
            <app-admin-contract-clusters
              [contractNumber]="contractFormGroup.get('number').value"
              class="col-xl-12 mt-3"
            />
          }
        </div>
      </div>
    }

    <div class="card-footer">
      @if (mode == 'create') {
        <button
          (click)="createContract()"
          [disabled]="contractFormGroup.invalid"
          [innerHtml]="'ajouter' | translate"
          class="btn btn-sm btn-primary mr-2"
        ></button>
      }
      @if (mode == 'update') {
        <button
          (click)="updateContract()"
          [disabled]="contractFormGroup.invalid"
          [innerHtml]="'Enregistrer' | translate"
          class="btn btn-sm btn-primary mr-2"
        ></button>
      }
      <button
        (click)="contractFormGroup.reset(); back()"
        [innerHtml]="'Annuler' | translate"
        class="btn btn-sm btn-danger"
      ></button>
    </div>
  </div>
</div>
